import {
  Box,
  Flex,
  Grid,
  GridItem,
  HStack,
  Image,
  Text,
  useBreakpointValue,
  VStack,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DashboardHeader from "../../../components/common/DashboardHeader";
import Loading from "../../../components/common/Loading";
import TraineeSidenav from "../../../components/trainee/courses/Sidenav";
import Audio from "../../../components/trainee/resources/Audio";
import Documents from "../../../components/trainee/resources/Documents";
import Images from "../../../components/trainee/resources/Images";
import Video from "../../../components/trainee/resources/Video";
import folder from "../../../img/folder.svg";
import rarrow from "../../../img/rarrow.svg";
import { IResources } from "../../../models/course/course-resource.model";
import trResourcesService from "../../../services/trainer/trResources.service";
import TraineeMobileNav from "../../../components/common/TraineeMobileNav";

const Resources = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(true);
  const [isDocument, setDocument] = useState(false);
  const [isVideo, setVideo] = useState(false);
  const [isAudio, setAudio] = useState(false);
  const [isLinks, setLinks] = useState(false);
  const [isImages, setImages] = useState(false);
  const [isResources, setResources] = useState(true);
  const [courseId, setCourseId] = useState("");
  const [videos, setVideoResources] = useState<IResources[]>();
  const [images, setImageResources] = useState<IResources[]>();
  const [audios, setAudioResources] = useState<IResources[]>();
  const [documents, setDocumentResources] = useState<IResources[]>();
  const [resources, setCourseResources] = useState<IResources[]>();
  const courseName: null | string = localStorage.getItem("courseName");
  const showSideNav = useBreakpointValue({ base: false, md: true, lg: true });
  const params = useParams();
  const course_id: any = params.course_id;

  useEffect(() => {
    const course_id: any = params.course_id;
    setDocument(false);
    setResources(true);
    setVideo(false);
    setAudio(false);
    setLinks(false);
    setImages(false);
    trResourcesService
      .getCourseResources(course_id)
      .then((response) => {
        const resources: IResources[] = response.data.course.resources;
        const videos = resources.filter((each) => each.file_type == "Video");
        const audios = resources.filter((each) => each.file_type == "Audio");
        const documents = resources.filter(
          (each) => each.file_type == "Document"
        );
        const images = resources.filter((each) => each.file_type == "Image");
        setCourseResources(response.data.course.resources);
        setVideoResources(videos);
        setAudioResources(audios);
        setImageResources(images);
        setDocumentResources(documents);
        setLoading(false);
      })
      .catch((err) => err);

    setCourseId(course_id);
  }, [reload]);

  const reloadData = () => {
    setReload(!reload);
  };

  const selectDocument = () => {
    setDocument(true);
    setResources(false);
    setVideo(false);
    setAudio(false);
    setLinks(false);
    setImages(false);
  };
  const selectVideo = () => {
    setDocument(false);
    setResources(false);
    setVideo(true);
    setAudio(false);
    setLinks(false);
    setImages(false);
  };
  const selectAudio = () => {
    setDocument(false);
    setResources(false);
    setVideo(false);
    setAudio(true);
    setLinks(false);
    setImages(false);
  };

  const selectImages = () => {
    setDocument(false);
    setResources(false);
    setVideo(false);
    setAudio(false);
    setLinks(false);
    setImages(true);
  };
  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Box width="100hw">
          <DashboardHeader />

          <Box
            bg="#F9F8F8"
            minHeight="100vh"
            height="auto"
            width="100%"
          >
            {!showSideNav && <TraineeMobileNav courseId={course_id || ""} />}
            <Flex
              width="90%"
              mx="auto"
              pb="120px"
              pt={["50px", "60px", "60px", "80px"]}
              boxSizing="border-box"
            >
              {showSideNav && <TraineeSidenav />}
              <VStack
                minWidth={{ lg: "80%", md: "70%", sm: "95%", base: "95%" }}
                overflowX={"scroll"}
                className="scroll-hidden"
                mr="auto"
                boxSizing="border-box"
              >
                <HStack width={"100%"} height={"2rem"} mr="auto">
                  <Text
                    as="span"
                    fontSize={["16px", "20px"]}
                    isTruncated
                    maxWidth={["180px", "200px", "350px", "500px"]}
                  >
                    {courseName && courseName.replaceAll(/"/g, "")}
                  </Text>
                  <Image src={rarrow} />
                  <Text as="span" fontSize={["16px", "20px"]} color={"#616161"}>
                    Resources
                  </Text>
                </HStack>
                {isResources && (
                  <Box
                    width="100%"
                    mx="auto"
                    pb={{
                      lg: "200px",
                      md: "150px",
                      sm: "110px",
                      base: "110px",
                    }}
                    px={{
                      lg: "2rem",
                      md: "2rem",
                      sm: "1.8rem",
                      base: "1rem",
                    }}
                    pt={{ lg: "3rem", md: "2.6rem", sm: "2rem", base: "2rem" }}
                    bg="white"
                  >
                    <Text
                      color="#1E1E1E"
                      fontSize={{
                        lg: "28px",
                        md: "20px",
                        sm: "18px",
                        base: "18px",
                      }}
                      pb={["20px", "30px"]}
                      fontWeight="600"
                    >
                      Resources{" "}
                    </Text>
                    <Grid
                      templateColumns={{
                        base: "repeat(2, auto)",
                        md: "repeat(2, auto)",
                        lg: "repeat(3, auto)",
                      }}
                      gap={["4px", "1rem"]}
                    >
                      <GridItem>
                        <Flex
                          cursor="pointer"
                          onClick={() => selectDocument()}
                          pb="14px"
                          pt="10px"
                          pl={["8px", "28px", "28px", "38px"]}
                          borderRadius="5px"
                          border="0.5px solid"
                          borderColor="#9E9E9E"
                        >
                          <Image
                            height={["30px", "30px", "40px", "50px"]}
                            width={["30px", "30px", "40px", "50px"]}
                            src={folder}
                          />
                          <Text
                            pt={["10px", "15px", "15px", "20px"]}
                            fontWeight="600"
                            fontSize={["14px", "15px", "16px", "18px"]}
                            pb="10px"
                            color="#616161"
                            isTruncated
                          >
                            Documents
                          </Text>
                        </Flex>
                      </GridItem>
                      <GridItem>
                        <Flex
                          cursor="pointer"
                          onClick={() => selectVideo()}
                          pb="14px"
                          pl={["8px", "28px", "28px", "38px"]}
                          pt="10px"
                          borderRadius="5px"
                          border="0.5px solid"
                          borderColor="#9E9E9E"
                        >
                          <Image
                            height={["30px", "30px", "40px", "50px"]}
                            width={["30px", "30px", "40px", "50px"]}
                            src={folder}
                          />
                          <Text
                            pt={["10px", "15px", "15px", "20px"]}
                            fontWeight="600"
                            fontSize={["14px", "15px", "16px", "18px"]}
                            pb="10px"
                            color="#616161"
                          >
                            Video
                          </Text>
                        </Flex>
                      </GridItem>
                      <GridItem>
                        <Flex
                          cursor="pointer"
                          onClick={() => selectAudio()}
                          pb="14px"
                          pl={["18px", "28px", "28px", "38px"]}
                          pt="10px"
                          borderRadius="5px"
                          border="0.5px solid"
                          borderColor="#9E9E9E"
                        >
                          <Image
                            height={["30px", "30px", "40px", "50px"]}
                            width={["30px", "30px", "40px", "50px"]}
                            src={folder}
                          />
                          <Text
                            pt={["10px", "15px", "15px", "20px"]}
                            fontWeight="600"
                            fontSize={["14px", "15px", "16px", "18px"]}
                            pb="10px"
                            color="#616161"
                          >
                            Audio
                          </Text>
                        </Flex>
                      </GridItem>
                      <GridItem>
                        <Flex
                          cursor="pointer"
                          onClick={() => selectImages()}
                          pb="14px"
                          pl={["18px", "28px", "28px", "38px"]}
                          pt="10px"
                          borderRadius="5px"
                          border="0.5px solid"
                          borderColor="#9E9E9E"
                        >
                          <Image
                            height={["30px", "30px", "40px", "50px"]}
                            width={["30px", "30px", "40px", "50px"]}
                            src={folder}
                          />
                          <Text
                            pt={["10px", "15px", "15px", "20px"]}
                            fontWeight="600"
                            fontSize={["14px", "15px", "16px", "18px"]}
                            pb="10px"
                            color="#616161"
                          >
                            Image
                          </Text>
                        </Flex>
                      </GridItem>
                    </Grid>
                  </Box>
                )}
                {isDocument && (
                  <Documents files={documents} reload={reloadData} />
                )}
                {isVideo && <Video files={videos} reload={reloadData} />}
                {isAudio && <Audio files={audios} reload={reloadData} />}
                {isImages && <Images files={images} reload={reloadData} />}
              </VStack>
            </Flex>
          </Box>
        </Box>
      )}
    </>
  );
};

export default Resources;
